//import { BOToothStateDetailToothFace } from './../../../models/odo/BOToothStateDetailToothFace.model';
import { Component, ViewChild, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef, Renderer2, ChangeDetectorRef, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BOToothStateType } from '../../../models/odo/BOToothStateType.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { BOToothStateDetail } from '../../../models/odo/BOToothStateDetail.model';
import { BOToothStateDetailToothFace } from '../../../models/odo/BOToothStateDetailToothFace.model';
import { Utilities } from "../../../common/utilities";
import { ToastrService } from "ngx-toastr";
import { MatTable } from '@angular/material/table';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { BOSubServiceType } from '../../../models/BOSubServiceType.model';
import { BOItem } from '../../../models/BOItem.model';
import { forkJoin, Subscription } from 'rxjs';
import { ToothFaceTypeService } from '../../../services/toothFaceType.service';
import { ToothStateTypeService } from '../../../services/toothStateType.service';
import { ToothStateDetailService } from '../../../services/toothStateDetail.service';
import 'web-animations-js';  // Soporte para requestAnimationFrame
import { BOToothFaceType } from '../../../models/odo/BOToothFaceType.model';
import { ToothTypeService } from '../../../services/toothType.service';
import { BOToothType } from '../../../models/odo/BOToothType.model';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { BOOdontologyBackgroundType } from '../../../models/odo/BOOdontologyBackgroundType.model';
import { ToothOdontogramaService } from '../../../services/odo/ToothOdontograma.service';
import { VoiceWritingComponent } from '../../voiceWriting/voiceWriting.component';
import { VoiceWriting2Service } from '../../../services/voiceWriting2.service';
import { VoiceWriting2Component } from '../../voice-writing2/voice-writing2.component';
import { BOCurrentPathColor } from '../../../models/odo/BOCurrentPathColor.model';
import { DialogConfirmService } from '../../../services/dialog-confirm.service';
import { BOToothDiagnostics } from '../../../models/newOdonto/BOToothDiagnostics.model';

type ExtractedInfo = {
  number: number;
  zone: string;
  } | null;
@Component({
  selector: 'app-tooth-state',
  templateUrl: './tooth-state.component.html',
  styleUrls: ['./tooth-state.component.css']
})


export class ToothStateComponent  implements OnInit, OnDestroy{
//#region ViewChild

  @ViewChild('toothState', { static: false }) modal!: ModalDirective;
  @ViewChild('toothStateDetailTable') toothStateDetailTable:MatTable<BOToothStateDetail>;
  @ViewChild('toothStateDetailTableShort') toothStateDetailTableShort:MatTable<BOToothStateDetail>;
  @ViewChildren('svgLayer') svgLayers!: QueryList<ElementRef<SVGSVGElement>>;
  @ViewChildren('path')  pathElements!: QueryList<ElementRef>;
  @ViewChildren('pathMd')  pathElementsMd!: QueryList<ElementRef>;
  @ViewChildren('pathMi')  pathElementsMi!: QueryList<ElementRef>;
  @ViewChildren('pathMain')  pathElementsMain!: QueryList<ElementRef>;
  @ViewChildren('pathBase')  pathElementsBase!: QueryList<ElementRef>;
  @ViewChild('endPath', { static: true }) endPath: ElementRef;
  @ViewChild('voiceWritingComponent') voiceWritingComponent!: VoiceWritingComponent;
  @ViewChild('voiceWriting2Component') voiceWriting2Component!: VoiceWriting2Component;

  @ViewChild('vestibularCheckbox') vestibularCheckbox!: MatCheckbox;
  @ViewChild('medialCheckbox') medialCheckbox!: MatCheckbox;
  @ViewChild('distalCheckbox') distalCheckbox!: MatCheckbox;
  @ViewChild('palatinoCheckbox') palatinoCheckbox!: MatCheckbox;
  @ViewChild('centerCheckbox') centerCheckbox!: MatCheckbox;

//
  @Output() dataUpdated = new EventEmitter<{toothId:number, tsd:BOToothStateDetail}>();
  @Output() dataUpdatedSmaller = new EventEmitter<{toothId:number, tsd:BOToothStateDetail}>();
  @Output() stateUpdated = new EventEmitter<{toothId:number, tsd:BOToothStateDetail}>();
  @Output() stateErased = new EventEmitter<{toothId:number, stateId:number}>();

 // @Output() stateErasedTS = new EventEmitter<{toothId:number, stateId:number, tsd:BOToothStateDetail}>();


  @ViewChild('toothSelect') toothSelect!: MatSelect;
//#endregion ViewChild

  currentColor: BOCurrentPathColor=new BOCurrentPathColor();
  private voiceSub!: Subscription;
  stopSignal: boolean = false;
  private odontoType:number=0;

//#region declarations
  private updating = false;


  showSaveState=false;
  statesDesplayedTable: string[] = ['toothStateId','observations', 'treatment', 'fixed','X'];
  statesDesplayedTableShort: string[] = ['toothStateId', 'triage', 'fixed', 'X'];

  clinicHistoryId:number=0;
  personId:number=null;
  odontogramaId:number=null;

  toothId="";
  positionInMouth="";
  toothStateId="";


  toothStateDetailIdTemp=0;
  positionCurrentToothStateDetail=0;

  currentToothStateDetail:BOToothStateDetail=new BOToothStateDetail();
  showAddNewStateBtn=false;
  showLastToothStateDetailNav=false;
  showSaveToothStateBtn=false;
  bridgeElement: any;
  private clickTimeout: any = null;
  private delay = 250;

  vestibularFromFacesChoosed=false;
  medialFromFacesChoosed=false;
  distalFromFacesChoosed=false;
  palatinoFromFacesChoosed=false;
  todosFromFacesChoosed=false;
  centerFromFacesChoosed=false;

  subServiceTypeListShort             :BOSubServiceType   [] = [];
  subServiceTypeList                  :BOSubServiceType   [] = [];
  serviceTypeList                     :BOItem             [] = [];
  serviceTypeListShort                :BOItem             [] = [];
  backgroundTypesList                 :BOOdontologyBackgroundType[]=[];

  triageState : BOItem []=[{id:1, code:'01', name:'Urgente'},{id:2, code:'02', name:'Grave'}, {id:3, code:'03', name:'Leve'}];


  private lastSelectedPath: ElementRef | null = null; // Guardar referencia del último seleccionado

  busyData$:Subscription;

  checkboxes = [
    { id:1,controlName: 'vestibular', label: 'V' },
    { id:2,controlName: 'medial', label: 'M' },
    { id:3,controlName: 'distal', label: 'D' },
    { id:4,controlName: 'palatino', label: 'P' },
    { id:5,controlName: 'center', label: 'O' }

  ];


  toothTypeList: BOToothType[]=[];

  toothStateTypeList: BOToothStateType[]=[];

  toothStateList:BOToothStateDetail[]=[]

  toothFacesTemp: BOToothStateDetailToothFace[]=[];

  toothFaceTypeList:BOToothFaceType[]=[];

  teethWithIncisal:number[]=[11,12,13,21,22,23,31,32,33,41,42,43,51,52,53,61,62,63,71,72,73,81,82,83];
  showIncisal:boolean=false;

//#region fill toothDiagnostics

  toothDiagnostics: BOToothDiagnostics[]=[];

  fillToothDiagnostics():BOToothDiagnostics[]
  {
    let tempToothDiagnostics=[
      {
        diagnosticCode:"K2A",
        margin:"md",
        verticalPosition:"bottom",
        faces:['vestibular', 'palatino','mesial','distal']
      },
      {
        diagnosticCode:"K31",
        margin:"md",
        verticalPosition:"bottom",
        faces:['vestibular', 'palatino','mesial','distal']
      },
      {
        diagnosticCode:"K18B",
        margin:"md",
        verticalPosition:"bottom",
        faces:['vestibular', 'palatino','mesial','distal']
      },
      {
        diagnosticCode:"K55Y",
        margin:"md",
        verticalPosition:"bottom",
        faces:['vestibular', 'palatino','mesial','distal']
      }
    ];

          return tempToothDiagnostics;
  }


//#endregion fill toothDiagnostics


  toothStateForm= this._formBuilder.group({
    toothStateId:   ['', Validators.required],
    vestibular: [false],
    medial: [false],
    distal: [false],
    palatino: [false],
    center: [false],
    fixed:[false],
    triage:[3, Validators.required],
    observations:[''],
    treatment:[''],
    totalToothStateDetailList:   [{ value: '', disabled: true }],
    counterToothStateDetail:     [{ value: '', disabled: true }]

  })

  selectedToothTypeId: number | null = null;
  selectedToothButtonOption: number | null = null;
  toothStateIdTemp:number=1000;

isTableVisible: boolean = false; // Inicialmente visible

  // Método para alternar la visibilidad de la tabla
  toggleTableVisibility(): void {
    this.isTableVisible = !this.isTableVisible;
  }


  asignTrueFromStateDetail(faces: BOToothStateDetailToothFace[]): void {
    // Primero limpiamos todos los checkboxes
    this.checkboxes.forEach(checkbox => {
      this.toothStateForm.get(checkbox.controlName)?.setValue(false);
    });

    // Luego marcamos los correspondientes
    faces.forEach(face => {
      const checkboxConfig = this.checkboxes.find(c => c.id === face.toothFaceId);

      if (checkboxConfig) {
        const control = this.toothStateForm.get(checkboxConfig.controlName);
        if (control) {
          control.setValue(true);

          // Si es el checkbox 'todos', manejamos lógica especial
          // if (checkboxConfig.controlName === 'todos') {
          //   this.handleTodosCheckboxTrue(true);
          // }
        }
      }
    });
  }


  //#endregion declarations

  constructor
  (
            private _formBuilder     : FormBuilder,
            private _toastr          : ToastrService,
            private _toothFaceType   : ToothFaceTypeService,
            private _toothStateType  : ToothStateTypeService,
            private _toothStateDetail: ToothStateDetailService,
            private _toothType       : ToothTypeService,
            private _renderer        : Renderer2,
            private _changeDetectorRef : ChangeDetectorRef,
            private _odontogramaService: ToothOdontogramaService,
            private _voiceService      : VoiceWriting2Service,
            private _dialogConfirm     : DialogConfirmService,

           // private _OdontologyBackgroundType: OdontologyBackgroundTypeService,


    // private ngZone: NgZone

   ) { }

  // testClick(event:MouseEvent)
  // {
  //   console.log('Clickeando es:', event);
  //   this._toastr.info('Click pillado', 'Ha identificado el click')

  // }

  ngAfterViewInit(): void {

    console.log("Modal inicializado:", this.modal);
    console.log('En ngAfterViewInit Después de renderizar:', this.pathElements);

    if (this.voiceWritingComponent) {
      this.voiceWritingComponent.setFormGroup(this.toothStateForm);
    }
    if(this.voiceWriting2Component) {
            this.voiceWriting2Component.setFormGroup(this.toothStateForm);

    }


    this.handleTodosCheckbox();
  }

  ngOnInit(): void
  {

    this.fetchData();

  this.voiceSub = this._voiceService.uiCommands$.subscribe(cmd =>
  {
      console.log("En tsc entra a voiceSub");
      console.log('En tsc ->ngOnInit cmd.type es:', cmd.type);


      switch (cmd.type)
      {

        // case 'save-tooth-select':
        //   console.log('Entra a save-tooth´-select:');
        //   this.toothSelect?.open();
        //   break;
        case 'open-tooth-select':
          console.log('toothSelect:', this.toothSelect);
          this.toothSelect?.open();
          break;

        case 'select-tooth':
          this.selectToothById(cmd.payload);

          // Buscar el mat-option correspondiente
          const selectedOption = this.toothSelect.options.find(
            option => option.value === cmd.payload
          );

          // Emitir manualmente el evento como si el usuario lo hubiera hecho
          if (selectedOption) {
            const event = { source: this.toothSelect, value: cmd.payload } as MatSelectChange;
            this.onToothChange(event);
          }
          break;

        case 'select-check-v':
          console.log('Entra a select-check-v');
          this.processSelectCheck('v');
          break;

        case 'select-check-d':
          console.log('Entra a select-check-d');
          this.processSelectCheck('d');
          break;
        case 'select-check-m':
          console.log('Entra a select-check-m');
          this.processSelectCheck('m');
          break;

        case 'select-check-p':
          console.log('Entra a select-check-p');
          this.processSelectCheck('p');
          break;

        case 'select-check-c':
          console.log('Entra a select-check-c');
          this.processSelectCheck('c');
          break;

        case 'select-color':
          console.log('Entra a select-color');
          this.changeCurrentColor();
          this._toastr.success("Checkbox", "captura Checkbox");
          break;

        default:
          // Manejar casos no contemplados (opcional)
          console.warn(`Tipo de comando no reconocido: ${cmd.type}`);
          break;
      }

  });

 this.toothDiagnostics= this.fillToothDiagnostics();
  }

  openModal(toothId?:string): void {
    console.log("Entra a openModal, toothId recibido es:",toothId);
    this.toothId=toothId;

    if (this.modal) {
      this.modal.config = { backdrop: "static", keyboard: false };
      this.modal.show();
    } else {
      console.error("No se encontró el modal en firstExam.");
    }
  }
//TODO (se debe capturar personId, odontogramaId en los parámetros de este método)
  openModalFromOdontograma(clinicHistoryId:number, personId:number, toothId?:string, positionInMouth?:string): void
  {
      console.log("Entra a openModalFromOdontograma. positionInMouth is", positionInMouth, "personId es:", personId);
    this.showIncisal=false;
//this._voiceService['uiCommandSubject'].next({ type: 'open-tooth-select' });


      this.clinicHistoryId=clinicHistoryId;
      this.personId=personId;
      this.toothStateList=[];
      this.positionInMouth=positionInMouth;
      this.hideAllPaths();
      //data to retrieve tsd
      let toothIdnumber=parseInt(toothId);
      this.selectedToothTypeId=parseInt(toothId);
      this.positionCurrentToothStateDetail=0;

      this.toothId=toothId;
      console.log('toothIdnumber es:',toothIdnumber, ' y su tipo es', typeof(toothIdnumber) );

        if(this.teethWithIncisal.includes(toothIdnumber)) this.showIncisal=true;
        //console.log("después de eval, showIncisal es:", this.showIncisal);
        if (this.modal)
        {
          this.toothStateList.length>0?this.showAddNewStateBtn=true:this.showAddNewStateBtn=false;
          this.modal.config = { backdrop: "static", keyboard: false };
          this.modal.show();

          setTimeout(() => {
             this.hideAllPaths();

            this.busyData$ = forkJoin({
              resultToothFaceType: this._toothFaceType.getAll(),
              resultToothStateType: this._toothStateType.getAll(),
              resultToothType: this._toothType.getAll(),
              resultOdontogramaId: this._odontogramaService.getOdontogramaIdByChIdAndPersonId(clinicHistoryId, personId),
              resultToothStateDetails:   this._toothStateDetail.getToothStateDetailsByClinicHistoryId(clinicHistoryId)
            }).subscribe({
              next: ({
                resultToothFaceType,
                resultToothStateType,
                resultToothType,
                resultToothStateDetails,
                resultOdontogramaId,
                // resultBackgroundType

              }) => {
                this. toothFaceTypeList=resultToothFaceType;
                this.toothStateTypeList = resultToothStateType;
                this.toothTypeList= resultToothType,
                this.toothStateList= resultToothStateDetails,
                this.odontogramaId=resultOdontogramaId,
                console.log('En openModalFromOdontograma, this.toothStateList initial is:',this.toothStateList )
                console.log('En openModalFromOdontograma, odontogramaId is:',this.odontogramaId);

                this.toothStateList= resultToothStateDetails.filter(ts=>ts.toothTypeId==toothIdnumber)
                 .map(item => ({ ...item, selected: false })); // normaliza todos a false
                console.log('En openModalFromOdontograma, this.toothStateList filtered complete is:',this.toothStateList )
                console.log('En openModalFromOdontograma, this.toothStateList filtered length is:',this.toothStateList.length )


                if(this.toothStateList.length>0)
                {
                  console.log('Entra a if(this.toothStateList.length>0)');
                      if(this.lastSelectedPath?.nativeElement)
                      {
                                  this.lastSelectedPath.nativeElement.style.display='none';

                      }
                  this.showAddNewStateBtn=true;
                  this.showLastToothStateDetailNav=false;

                  this.currentToothStateDetail=this.toothStateList[0];
                  this.positionCurrentToothStateDetail=0;
                  this.selectToothStateDetail(this.toothStateList[0]); // ← marca solo el [0]

                  this.positionInMouth=positionInMouth;
                  this.toothStateId=this.currentToothStateDetail.toothStateId.toString();

                  let layerId=positionInMouth+'-'+this.toothStateId;

//                let currentLayer= this.svgLayers.find(x=>x.nativeElement['id']==layerId);
 //               console.log('currentLayer is:', currentLayer);
                    this.hideEndPath();

                  this.setCurrentLayer(layerId);
                  this.showPath();


                }
                else
                {

                  console.log('Entra al else de   if(this.toothStateList.length>0)');
                      if(this.lastSelectedPath?.nativeElement)
                      {
                                  this.lastSelectedPath.nativeElement.style.display='none';

                      }
                  this.currentToothStateDetail=null;
                  this.positionInMouth=positionInMouth;
                  this.fillToothStateForm();
                  let baseLayer='base-'+positionInMouth;
                   console.log('baseLayer is:', baseLayer);
                //  this.setBaseCurrentLayer(baseLayer);
                }

                this.fillToothStateForm();
                this._changeDetectorRef.detectChanges();
              },
              error: (err) => {
                console.error('Error al cargar los datos: ', err);
              },
              complete: () => {
                console.log('Carga de datos completa');
              }
            });

          }, 0);


        }
        else
        {
          console.error("No se encontró el modal en firstExam.");
        }
  }

   close(): void {
    if (this.modal) {
      this.modal.hide();
    } else {
      console.error("No se pudo cerrar el modal.");
    }
   }

  private handleTodosCheckbox() {

    // Suscripción a los checkboxes individuales
    ['vestibular', 'medial', 'distal', 'palatino', 'center'].forEach(controlName => {
      this.toothStateForm.get(controlName).valueChanges.subscribe(() => {
        if (this.updating) return;

        const allChecked = ['vestibular', 'medial', 'distal', 'palatino', 'center']
          .every(name => this.toothStateForm.get(name).value);

        this.updating = true;
        // this.toothStateForm.get('todos').setValue(allChecked, { emitEvent: false });
        // this.updating = false;
      });
    });
  }

  saveToothStateDetail():void
  {
    console.log('Entra a saveToothStateDetail');

    const pos = this.positionCurrentToothStateDetail;

    // console.log('this.toothStateList es:', this.toothStateList);
    // console.log('pos es:', pos);
    console.log('this.toothStateList[pos] es:', this.toothStateList[pos]);

    // Verifica si existe un elemento en la posición actual
    const hasCurrentElement = this.toothStateList[pos] !== null &&
                              this.toothStateList[pos] !== undefined;

    if (!hasCurrentElement)
    {
      console.log('Entra a verifyTemp==-1, es decir no tiene elementos');

      const toothStateId = parseInt(this.toothStateForm.get('toothStateId').value, 10);
      const st = this.createBOToothStateDetail();

      // Verifica duplicados antes de llamar al servidor
      const exists = this.toothStateList.some(elem => elem.toothStateId === st.toothStateId);
      if (exists)
      {
        this._toastr.error("Fallo", "Ya existe este diagnóstico");
        return;
      }

      console.log("tsList antes de agregar nuevo tsd tiene:", this.toothStateList.length, " elem");

      this._toothStateDetail.saveToothStateDetail(st).subscribe(x => {
        // 1. Guardar el id temporal y añadir el nuevo elemento al array
        this.toothStateIdTemp = x.id;
        this.toothStateList = [...this.toothStateList, x];

        console.log("tsList DESPUÉS de agregar nuevo tsd tiene:", this.toothStateList.length, " elem y es:", this.toothStateList);

        // 2. Buscar la posición (índice) del nuevo item en el array
        const posNewItem = this.toothStateList.findIndex(tsd => tsd.toothStateId === x.toothStateId);
        console.log("La pos (índice) del nuevo tsd es:", posNewItem);

        // 3. Emitir evento de actualización al componente padre
        this.dataUpdated.emit({ toothId: x.toothTypeId, tsd: x });

        // 4. Notificación de éxito
        this._toastr.success("Se guardó el estado", "Éxito", {
          timeOut: 600
        });

        // 5. Actualizar la vista del estado guardado
        this.showStateFromSaveState(toothStateId);

        // 6. Posicionar en el nuevo elemento (último del array)
        const position = this.toothStateList.length - 1;
        this.currentToothStateDetail = this.toothStateList[position];

        // 7. Deseleccionar todos y seleccionar solo el nuevo elemento
        this.toothStateList = this.toothStateList.map(item => ({ ...item, selected: false }));

        // Usar el índice correcto: el último elemento recién añadido
        this.toothStateList[position].selected = true;

        // 8. Actualizar índice de posición actual
        this.positionCurrentToothStateDetail = position;

        // 9. Actualizar formulario y controles de UI
        this.fillToothStateForm();
        this.showAddNewStateBtn = true;
        this.showLastToothStateDetailNav = false;
        this.toothStateDetailIdTemp += 1;

        // Toggle del botón de guardar (simplificado)
        this.showSaveToothStateBtn = false;
      });
    } else {
      this.toothStateDetailEdit();
    }
  }


  saveToothStateDetail2():void
  {
    try
    {
        if(this.toothStateList.length>0)
        {
          this.toothStateDetailGreaterZero();
        }
        else
        {
          this.toothStateDetailSmallerZero();
        }
    }
    catch (error)
    {
      this._toastr.error('Fallo en guardar','No se ha guardado el diente')
    }
  }

  toothStateDetailSmallerZero():void
  {
    console.log("Entra a smallerThanZero");

    let toothStateId=parseInt(this.toothStateForm.get('toothStateId').value);
    let triageIdTemp=parseInt(this.toothStateForm.get('triage').value);

    this.getCheckboxValues(toothStateId);

    const st=this.createBOToothStateDetail();

    this._toothStateDetail.saveToothStateDetail(st).subscribe
    (x=>{
      this.toothStateIdTemp=x.id;


      console.log('El objeto devuelto es:', x);
        this.dataUpdatedSmaller.emit({toothId:x.toothTypeId, tsd:x});

      this._toastr.success("Se guardó el estado", "Éxito", {
      timeOut: 600
      });

    })
     st.id=this.toothStateIdTemp;
    // this.toothStateIdTemp+=1;


    this.toothStateList = [...this.toothStateList, st];
    this.showStateFromSaveState(toothStateId);

    let position=this.toothStateList.length-1;
    this.currentToothStateDetail=this.toothStateList[position];
    this.positionCurrentToothStateDetail=position;

    this.fillToothStateForm();
    this.showAddNewStateBtn=true;
    //this.showLastToothStateNav=false;
    this. showLastToothStateDetailNav=false;

    this.toothStateDetailIdTemp+=1;
    this.showSaveToothStateBtn=true?this.showSaveToothStateBtn=false:this.showSaveToothStateBtn=true;

  }


  toothStateDetailGreaterZero(): void {
    console.log('Entra a toothStateDetailGreterZero');

    const pos = this.positionCurrentToothStateDetail;

    // console.log('this.toothStateList es:', this.toothStateList);
    // console.log('pos es:', pos);
    console.log('this.toothStateList[pos] es:', this.toothStateList[pos]);

    // Verifica si existe un elemento en la posición actual
    const hasCurrentElement = this.toothStateList[pos] !== null &&
                              this.toothStateList[pos] !== undefined;

    if (!hasCurrentElement)
    {
      console.log('Entra a verifyTemp==-1, es decir no tiene elementos');

      const toothStateId = parseInt(this.toothStateForm.get('toothStateId').value, 10);
      const st = this.createBOToothStateDetail();

      // Verifica duplicados antes de llamar al servidor
      const exists = this.toothStateList.some(elem => elem.toothStateId === st.toothStateId);
      if (exists)
      {
        this._toastr.error("Fallo", "Ya existe este diagnóstico");
        return;
      }

      console.log("tsList antes de agregar nuevo tsd tiene:", this.toothStateList.length, " elem");

      this._toothStateDetail.saveToothStateDetail(st).subscribe(x => {
        // 1. Guardar el id temporal y añadir el nuevo elemento al array
        this.toothStateIdTemp = x.id;
        this.toothStateList = [...this.toothStateList, x];

        console.log("tsList DESPUÉS de agregar nuevo tsd tiene:", this.toothStateList.length, " elem y es:", this.toothStateList);

        // 2. Buscar la posición (índice) del nuevo item en el array
        const posNewItem = this.toothStateList.findIndex(tsd => tsd.toothStateId === x.toothStateId);
        console.log("La pos (índice) del nuevo tsd es:", posNewItem);

        // 3. Emitir evento de actualización al componente padre
        this.dataUpdated.emit({ toothId: x.toothTypeId, tsd: x });

        // 4. Notificación de éxito
        this._toastr.success("Se guardó el estado", "Éxito", {
          timeOut: 600
        });

        // 5. Actualizar la vista del estado guardado
        this.showStateFromSaveState(toothStateId);

        // 6. Posicionar en el nuevo elemento (último del array)
        const position = this.toothStateList.length - 1;
        this.currentToothStateDetail = this.toothStateList[position];

        // 7. Deseleccionar todos y seleccionar solo el nuevo elemento
        this.toothStateList = this.toothStateList.map(item => ({ ...item, selected: false }));

        // Usar el índice correcto: el último elemento recién añadido
        this.toothStateList[position].selected = true;

        // 8. Actualizar índice de posición actual
        this.positionCurrentToothStateDetail = position;

        // 9. Actualizar formulario y controles de UI
        this.fillToothStateForm();
        this.showAddNewStateBtn = true;
        this.showLastToothStateDetailNav = false;
        this.toothStateDetailIdTemp += 1;

        // Toggle del botón de guardar (simplificado)
        this.showSaveToothStateBtn = false;
      });
    } else {
      this.toothStateDetailEdit();
    }
  }
  toothStateDetailEdit():void
  {
        console.log('Entra a toothStateDetailEdit');
        console.log('this.positionCurrentToothStateDetail es:',this.positionCurrentToothStateDetail);

    let current= this.toothStateList[this.positionCurrentToothStateDetail];
    console.log('current es:', current);

    let idCurrent=current.id;

    let idTemp= this.toothStateList[this.positionCurrentToothStateDetail].toothStateDetailIdTemp;

    let toothStateId=parseInt(this.toothStateForm.get('toothStateId').value);
    this.toothStateId=toothStateId.toString();
    console.log(' this.toothStateId es:',  this.toothStateId);


    let triageIdTemp=parseInt(this.toothStateForm.get('triage').value)

    this.getCheckboxValues(toothStateId); //llena los FaceTypes

    let st=new BOToothStateDetail();
    st.id=idCurrent;
    st.toothStateDetailIdTemp=this.toothStateDetailIdTemp+1;
    st.toothTypeId=parseInt(this.toothId);
    st.toothStateId=toothStateId;
    st.personId=this.currentToothStateDetail.personId;
    st.odontogramaId=this.currentToothStateDetail.odontogramaId;
    st.date= new Date();
    st.clinicHistoryOdontologyId=this.currentToothStateDetail.clinicHistoryOdontologyId;
   // st.serviceDetailId=1;
    st.observations=this.toothStateForm.get('observations').value;
    //st.treatment=this.toothStateForm.get('treatment').value;
    //st.fixed=this.toothStateForm.get('fixed').value;
    // st.triage=triageIdTemp;
    // st.comodin='';
    st.toothFaces=this.toothFacesTemp;

        console.log('st enviado es:', st);

   // this.toothStateList.splice(this.positionCurrentToothStateDetail,1,st);
     // SOLUCIÓN 1: Crear nueva referencia del array
  // Esto garantiza que Angular detecte el cambio
  const newList = [...this.toothStateList];
  newList[this.positionCurrentToothStateDetail] = st;
  this.toothStateList = newList;
    this._changeDetectorRef.detectChanges();
    this._toothStateDetail.saveToothStateDetail(st).subscribe(x=>{
                    //  this.dataUpdated.emit();
      this.stateUpdated.emit({toothId:x.toothTypeId, tsd:x});

      this._toastr.success("Se guardó el estado", "Éxito", {
      timeOut: 600
      });
    })

    this.showPath();
    this.showAddNewStateBtn=true;
    this.showLastToothStateDetailNav=false;

    this.toothStateDetailIdTemp+=1;
    this.showSaveToothStateBtn=true?this.showSaveToothStateBtn=false:this.showSaveToothStateBtn=true;

  }


  createBOToothStateDetail():BOToothStateDetail
  {
    let toothStateId=parseInt(this.toothStateForm.get('toothStateId').value);
    let triageIdTemp=parseInt(this.toothStateForm.get('triage').value);

    this.getCheckboxValues(toothStateId);

    let st=new BOToothStateDetail();
    st.id=0;
    st.toothStateDetailIdTemp=this.toothStateDetailIdTemp+1;
    st.toothTypeId=parseInt(this.toothId);
    st.toothStateId=toothStateId;
    st.personId=this.personId;
    st.odontogramaId=this.odontogramaId;
    st.date= new Date();
    st.clinicHistoryOdontologyId=this.clinicHistoryId;
    //st.serviceDetailId=1;
    st.observations=this.toothStateForm.get('observations').value;
    // st.treatment=this.toothStateForm.get('treatment').value;
    // st.fixed=this.toothStateForm.get('fixed').value;
    // st.triage=triageIdTemp;
    // st.comodin='';
    st.toothFaces=this.toothFacesTemp;
    console.log('toothSD built is:',st);
    return st;
  }

  fillToothStateForm():void
  {
    console.log("Entra a fillToothStateForm");
    if(!this.currentToothStateDetail || this.currentToothStateDetail==null)
    {
      this.toothStateForm.patchValue({
        toothStateId:null,
        vestibular:false,
        medial:false,
        distal:false,
        palatino:false,
        center:false,
        fixed:false,
        triage:3,
        observations:'',
        treatment:'',
        counterToothStateDetail:this.positionCurrentToothStateDetail,
        totaltoothStateDetailList:this.toothStateList.length
      })

    }
    else
    {


      let faces=this.currentToothStateDetail.toothFaces;
      this.toothStateForm.patchValue({
        toothStateId:this.currentToothStateDetail.toothStateId,
        vestibular:false,
        medial:false,
        distal:false,
        palatino:false,
        center:false,
        // fixed:this.currentToothStateDetail.fixed,
        // triage:this.currentToothStateDetail.triage,
        observations:this.currentToothStateDetail.observations,
        //treatment:this.currentToothStateDetail.treatment,
        counterToothStateDetail:this.positionCurrentToothStateDetail +1,
        totalToothStateDetailList:this.toothStateList.length
      });

      this.asignTrueFromStateDetail(faces);
    }

  }
  getCheckboxValues(toothStateId:number)
  {
    console.log('Entra a getCheckboxValues y toothStateId es:',toothStateId);
        console.log("this.positionInMouth es:", this.positionInMouth);

    let layerId=this.positionInMouth+'-'+ toothStateId;
    console.log("layerId es:", layerId);
    //captura el layer:
    const targetSvg=this.svgLayers.find(x=>{
      return x.nativeElement.id==layerId;
    });

    let paths: NodeListOf<SVGElement>=null;

    if(targetSvg)
    {
          //console.log('En getCheckboxValues targetSvg es:', targetSvg);

          paths = targetSvg.nativeElement.querySelectorAll('path, circle');


           //console.log('In if targetSvd paths is:', paths);
    }



    this.toothFacesTemp=[];

    const result = this.checkboxes.map(checkbox => ({
      label: checkbox.label,
      value: this.toothStateForm.get(checkbox.controlName)?.value
    }));

    let fColor="";
    let fStroke="";

    result.forEach( c=>{
    //busca el color de la face
      switch (c.label.trim()) {
        case 'V':
          if(c.value)
            {
              fColor= this.getColorFromFaces(paths, layerId+'-vestibular');
              fStroke= this.getStrokeFromFaces(paths, layerId+'-vestibular');
              //console.log('fstroke vestibular is:', fStroke);

              this.toothFacesTemp.push({toothStateDetailId:0,toothFaceId:1, toothStateId:toothStateId, color:fColor, strokeColor:fStroke})
              //console.log('En getCheckValues, this.toothFacesTemp is:', this.toothFacesTemp);
          }
          break;
        case 'M':
          if(c.value){
            fColor= this.getColorFromFaces(paths, layerId+'-medial');
            fStroke= this.getStrokeFromFaces(paths, layerId+'-medial');

            //console.log('fstroke is:', fStroke);
           this.toothFacesTemp.push({toothStateDetailId:0,toothFaceId:2, toothStateId:toothStateId, color:fColor,strokeColor:fStroke})
        }
        //console.log('En getCheckValues, this.toothFacesTemp is:', this.toothFacesTemp);
          break;
        case 'D':
          if(c.value){
            fColor= this.getColorFromFaces(paths, layerId+'-distal');
            fStroke= this.getStrokeFromFaces(paths, layerId+'-distal');

            //console.log('fstroke is:', fStroke);
           this.toothFacesTemp.push({toothStateDetailId:0,toothFaceId:3, toothStateId:toothStateId, color:fColor, strokeColor:fStroke})
        }
        //console.log('En getCheckValues, this.toothFacesTemp is:', this.toothFacesTemp);
          break;
        case 'P':
          if(c.value){
            fColor= this.getColorFromFaces(paths, layerId+'-palatino');
            fStroke= this.getStrokeFromFaces(paths, layerId+'-palatino');
            //console.log('fstroke is:', fStroke);
          this.toothFacesTemp.push({toothStateDetailId:0,toothFaceId:4, toothStateId:toothStateId, color:fColor, strokeColor:fStroke})
          //console.log('Procesando opción: Palatino');
          //console.log('En getCheckValues, this.toothFacesTemp is:', this.toothFacesTemp);
        }
          break;
        case 'O':
          if(c.value){
            fColor= this.getColorFromFaces(paths, layerId+'-center');
            fStroke= this.getStrokeFromFaces(paths, layerId+'-center');
            //console.log('fstroke is:', fStroke);
          this.toothFacesTemp.push({toothStateDetailId:0,toothFaceId:5, toothStateId:toothStateId, color:fColor, strokeColor:fStroke})
          //console.log('Procesando opcion Otro');
          //console.log('En getCheckValues, this.toothFacesTemp is:', this.toothFacesTemp);
        }
          break;

          default:
            console.log('Opción no válida. Por favor, seleccione una opción correcta.');
            break;
      }

    })
    //console.log(result); // Puedes usar este resultado como necesites
    return result;
  }

  //TODO numberxstring
  getNameOfState(id:number):string{
    return Utilities.getNameWithNumberFromList(id,this.toothStateTypeList)
  }

  getNameOfTriage(id:number):string{
    return Utilities.getTriageName(id,this.triageState)
  }

  onCheckboxChange(element: any): void {
    // Capturar el id del elemento y el `toothStateId`
    const elementId = element.id;
    const toothStateId = element.toothStateId;
 //   console.log(`Checkbox cambiado - Element ID: ${elementId}, ToothStateId: ${toothStateId}`);

    if (element.selected) {
      this.handleChecked(toothStateId, elementId);
    } else {
      this.handleUnchecked(toothStateId, elementId);
    }
  }

  handleChecked(toothStateId: number, elementId: number): void {

    // Buscar el `<path>` en el SVG por `id`
    let toothStateIdString= toothStateId.toString().trim();
    //let elementIdString=elementId.toString().trim();
    let elementName=this.checkboxes.find (cb=>cb.id==toothStateId).controlName;
    //elementIdString=toothStateIdString+elementIdString;
    let elementIdString=toothStateIdString;
    //console.log(`Element ID: ${elementIdString}`);

    const svgElement = document.getElementById(elementIdString);

    if (svgElement) {
      // Hacer visible el `<path>`
      svgElement.style.display = "inline";
      //console.log(`Path con id ${toothStateIdString} ahora es visible.`);
    } else {
      console.warn(`No se encontró el path con elementString ${elementIdString}`);
    }
  }

  handleUnchecked(toothStateId: number, elementId: number): void {

    // Transformar el `toothStateId` si es necesario
    //const transformedId = this.transformToothStateId(elementId);
    let toothStateIdString= toothStateId.toString().trim();

    // Buscar el `<path>` en el SVG por `id`
    const svgElement = document.getElementById(toothStateIdString);

    if (svgElement) {
      // Ocultar el `<path>`
      svgElement.style.display = "none";
      //console.log(`Path con id ${toothStateIdString} ahora está oculto.`);
    } else {
      console.warn(`No se encontró el path con id ${toothStateIdString}`);
    }
  }

  onCheckboxChangeTableResume(element: any): void {
    // Capturar el id del elemento y el `toothStateId`
    const elementId ="cbr-"+ element.id;
    const toothStateId = element.toothStateId;
    // console.log('checkbox elegido es:', element);
    // console.log(`Checkbox cambiado - Element ID: ${elementId}, ToothStateId: ${toothStateId}`);

    if (element.selected) {
      this.handleCheckedTableResume(toothStateId, elementId);
    } else {
      this.handleUncheckedTableResume(toothStateId, elementId);
    }
  }

  handleCheckedTableResume(toothStateId: number, elementId: string): void {
    //console.log(`Cb en handleChecked  - Element ID: ${elementId}, ToothStateId: ${toothStateId}`);

    // Buscar el `<path>` en el SVG por `id`
    let toothStateIdString= toothStateId.toString().trim();
    //let elementIdString=elementId.toString().trim();
    let elementName=this.checkboxes.find (cb=>cb.id==toothStateId).controlName;
    //elementIdString=toothStateIdString+elementIdString;
    let elementIdString=toothStateIdString;

    const svgElement = document.getElementById(elementIdString);

    if (svgElement) {
      // Hacer visible el `<path>`
      svgElement.style.display = "inline";
    } else {
      console.warn(`No se encontró el path con elementString ${elementIdString}`);
    }
  }

  handleUncheckedTableResume(toothStateId: number, elementId: string): void {

    // Buscar el `<path>` en el SVG por `id`
    const svgElement = document.getElementById(elementId);

    if (svgElement) {
      // Ocultar el `<path>`
      svgElement.style.display = "none";
      //console.log(`Path con id ${elementId} ahora está oculto.`);
    } else {
      console.warn(`No se encontró el path con id ${elementId}`);
    }
  }



  showStateFromSaveState(toothStateId: number): void
  {
    console.log("Entra en showStateFromSaveState");
    // Buscar el `<path>` en el SVG por `id`
    let toothStateIdString= toothStateId.toString().trim();
    const svgElement = document.getElementById(toothStateIdString);

    if (svgElement) {
      // Hacer visible el `<path>`
      svgElement.style.display = "inline";
      //console.log(`Path con id ${toothStateIdString} ahora es visible.`);
    } else {
      console.warn(`No se encontró el path con id ${toothStateIdString}`);
    }
  }

// Si los datos llegan dinámicamente, asegúrate de establecer `selected: true` en cada uno
  fetchData() {
  this.toothStateList = this.toothStateList.map(item => ({
    ...item,
    selected: false
    // Forzar que todos estén marcados por defecto
  }));

  this.toothStateList.forEach(st=>{
    this.showStateFromSaveState(st.toothStateId);
  })
  }

  //#region  changeColor

  changeColor(event: MouseEvent): void
  {

        //inicializa currentColor
    this.currentColor.mEvent=null;
    this.currentColor.stateId=null;
    this.currentColor.zone=null;


    console.log('Entra a changeColor  event is:', event);
    const target= event.target as HTMLElement;
    console.log('targetId is ', target.id);
    let stateIdAndPath=this.extractNumberAndZone(target.id);
    console.log('toothStateId is:', stateIdAndPath);
    console.log('stateIdAndPath.number es:', stateIdAndPath.number, ' y su tipo es:', typeof stateIdAndPath.number);
    let zone=stateIdAndPath.zone;
    let stateIdChoosed=stateIdAndPath.number;
      console.log('stateIdAndPath.zone es:', stateIdAndPath.zone, ' y su tipo es:', typeof stateIdAndPath.zone);
      console.log('stateIdChoosed is:', stateIdChoosed);

      //Crea el color actual
    this.currentColor.mEvent=event;
    this.currentColor.stateId=stateIdChoosed;
    this.currentColor.zone=zone;
      //
    console.log('En changeColor, currentColor es:', this.currentColor);
    this.getCheckboxValues(stateIdChoosed);
    this.zoneToForm(zone);

    const target2 = this.captureImage(event) as HTMLElement;
    console.log("En changeColor target2 es:", target2);

    if (target2)
    {
      const color = target2.style.fill;
      //const stroke= target2.style.stroke;
      let choosedColor= this.stateVerify(color, target2, zone);
    }
  }

  changeCurrentColor():void
  {
    console.log("Entra a changeCurrentColor y this.currentColor es:",this.currentColor);
    this.getCheckboxValues(this.currentColor.stateId);
    let idTarget=this.positionInMouth +"-"+this.currentColor.stateId+"-"+this.currentColor.zone;
    console.log("IdTarget es:", idTarget);
    const target=document.getElementById(idTarget);
    console.log("target es:", target);



    //const target = this.captureImage(this.currentColor.mEvent) as HTMLElement;


    if (target)
    {
      const color = target.style.fill;

      //const stroke= target2.style.stroke;
      let choosedColor= this.stateVerify(color, target, this.currentColor.zone);


    }

  }




  captureImage(event: any): any
  {
    console.log('Entra a captureImage');
    this.bridgeElement=null;
    //var upElement:HTMLElement = new HTMLElement();
    let target = event.target || event.srcElement || event.currentTarget;
    console.log('En captureImage target is:', target);
     if (target.tagName === 'path' || target.tagName === 'circle')
     {
      let idAttr = target.getAttribute('id');
      let idSvg = target.getAttribute('data-svg-id');

        if (idAttr && idSvg) {
            console.log('ID del elemento:', idAttr, ' | ID del SVG:', idSvg);

            // Selecciona el SVG contenedor
            const svgContainer = document.getElementById(idSvg);
            this.bridgeElement=svgContainer;

        } else {
        console.log('Clic fuera de un path o rect:', target);
        }
      }
      return this.bridgeElement;

  }

  stateVerify(color:string, target: HTMLElement, zone:string): string
  {

    console.log('Entra a stateVerify', 'color is:', color);
    switch (color) {
      case 'none':
        target.style.fill='red';
        return 'El estado es rojo';
      case 'red':
        target.style.fill='rgb(21, 66, 170)';
        return 'El estado es azul';
      case 'rgb(21, 66, 170)':
        target.style.fill='rgb(21, 70, 170)';
        target.style.stroke='red';
        return 'color:rgb(21, 70, 170)';
       case 'rgb(21, 70, 170)':
        target.style.fill='black';
        target.style.stroke='black';

        return 'color:black';
      case 'black':
        target.style.fill='none';
        this.toothStateForm.get(zone).setValue(false);

        return 'color:none';

      default:
        return 'Estado ninguno';
    }
  }


  onCheckboxClick(event: MatCheckboxChange): void
  {
    console.log('En tooth-state.componente, entra a onCheckboxClic');

    if(event)
    {
      console.log('Entra a if(event)');
      console.log('event es:', event);

      const checkboxId = event.source.id; // Obtenemos el ID
      console.log("en onCheckboxClick checkboxId es:", checkboxId);
        const isChecked = event.checked; // Estado actual
        this.toothStateId= this.toothStateForm.get('toothStateId').value;
      console.log("en onCheckboxClick this.toothStateId=:", this.toothStateId);

        const pathId=this.positionInMouth+'-'+this.toothStateId+"-"+checkboxId;
              console.log("en onCheckboxClick this.positionInMouth es:", this.positionInMouth,
                          ' this.toothStateId es:',this.toothStateId,' y  checkboxId es:', checkboxId);
      console.log("en onCheckboxClick pathId=:", pathId);

        const path=this.getPathById(pathId, this.positionInMouth);
       // let elem= this.getPathByIdByMargen(this.positionInMouth,pathId);

        let layerId=this.positionInMouth+'-'+this.toothStateId;

        console.log('En if(event) pasa layerId=this.position...');
        this.setCurrentLayer(layerId);
        console.log('En if(event) pasa this.setCurrentLayer(layerId)');

        this.handleCheckboxAction(checkboxId, isChecked, path);
        console.log('En if(event) pasa this.handleCheckboxAction(...');

    }
    else
    {
      this._toastr.warning('Falta estado', 'Debe elegir un estado para el diente');
    }

  }

  private handleCheckboxAction(id: string, estado: boolean, path: ElementRef): void
  {

    if(estado)
    {

      console.log('Entra al if de handleCheckboxAction estado es:', estado, ' y elem es:', path);


      if(path)
      {
      this._renderer.setStyle(path.nativeElement, 'display', 'inline');
      this._renderer.setStyle(path.nativeElement, 'fill', 'red' );
      }
      else
      {
        this._toastr.warning("Sin estado", "Debe definir un estado");

      }
    }
    else
    {

          console.log('Entra al else de handleCheckboxAction estado es:', estado);
          console.log('En  el else de handleCheckboxAction elem es:', path);

          if(path==undefined)
          {
            this._toastr.warning("Sin estado", "Debe definir un estado");
          }
          else{
            this._renderer.setStyle(path.nativeElement, 'fill', 'none' );
            this.toothFacesTemp=[];
          }
    }
  }
  //#endregion

  asignValuesToFaces(facesChoosed:BOToothStateDetailToothFace[]):void{

    facesChoosed.forEach(e=>{
      switch (e.toothFaceId) {
        case 1:
          this.vestibularFromFacesChoosed=true;
          //console.log('vestibularFromFacesChoosed es true');
          return 'vestibularFromFacesChoosed es true';
        case 2:
          this.medialFromFacesChoosed=true;
          //console.log('this.medialFromFacesChoosed es true');

          return;
        case 3:
          this.distalFromFacesChoosed=true;
          //console.log('this.distalFromFacesChoosed es true');

          return;
        case 4:
            this.palatinoFromFacesChoosed=true;
            //console.log('this.palatinoFromFacesChoosed es true');

          return;
        case 5:
              this.centerFromFacesChoosed=true;
              //console.log('this.centerFromFacesChoosed es true');

              return;
        default:
          //console.log('Estado ninguno es true');

          return 'Estado ninguno';
      }

    })

  }

  getStatesFromFaces(facesChoosed:BOToothStateDetailToothFace[]):string[]
  {
    // console.log('Entra a gestStatefromFaces');
    // console.log('this.positionInMouth es:', this.positionInMouth);
    // console.log('facesChoosed are:', facesChoosed);
    let face:string="";
    let faces:string[]=[];
    facesChoosed.forEach(e=>{
      let nameFace=this.toothFaceTypeList.find(x=>x.id==e.toothFaceId)?.name;
      let restOfWord = nameFace.slice(1);
      let firstLetterLower = nameFace.charAt(0).toLowerCase();
      let nameLower = firstLetterLower + restOfWord;

      nameFace=this.positionInMouth+'-'+e.toothStateId.toString()+'-'+nameLower;
      faces.push(nameFace);

    })

    return faces;

  }


  //#region  addNew and Navigation
  addNewState():void
  {
  console.log('Entra a addNewState');

      // console.log('counterToothStateDetail es:',this.positionCurrentToothStateDetail);
      // console.log('totaltoothStateDetailList es:',this.toothStateList);
      this. hideAllPaths();
      if(this.lastSelectedPath?.nativeElement)
      {
                  this.lastSelectedPath.nativeElement.style.display='none';
      }
      //
  if(this.showAddNewStateBtn && !this.showLastToothStateDetailNav)
  {
    console.log('Entra a if(this.showAddNewStateBtn && !this. showLastToothStateDetailNav): if 1 ')



      if(this.toothStateList.length>0)
      {
        //console.log('En if 1, entra a tootStateList.length>0');

        this.positionCurrentToothStateDetail=this.toothStateList.length;
        this.showAddNewStateBtn=false;
        this. showLastToothStateDetailNav=true;
        //this.showPath();
        this.clearToothStateForm();


        this.toothStateForm.patchValue({
          counterToothStateDetail:this.positionCurrentToothStateDetail,
          totalToothStateDetailList:this.toothStateList.length
        })


      }
      else{
        //console.log('En if 1, entra al else');

        this.clearToothStateForm();
        this.positionCurrentToothStateDetail=0;
        this.showAddNewStateBtn=true;
        this. showLastToothStateDetailNav=false;
      }
      this.showSaveToothStateBtn=true;


  }
  else if(!this.showAddNewStateBtn && this. showLastToothStateDetailNav)
  {
    // console.log('Entra a if(!this.showAddNewStateBtn && this. showLastToothStateDetailNav) ')
    // console.log('this.showAddNewStateBtn es:', this.showAddNewStateBtn);
    // console.log('this. showLastToothStateDetailNav es:', this. showLastToothStateDetailNav);


    if(this.toothStateList.length>0)
    {

      this.positionCurrentToothStateDetail=this.toothStateList.length-1;
      this.currentToothStateDetail=this.toothStateList[this.positionCurrentToothStateDetail];



      const faces=this.currentToothStateDetail.toothFaces;

      // console.log('counterToothStateDetail es:',this.positionCurrentToothStateDetail);
      // console.log('totaltoothStateDetailList es:',this.toothStateList);

      this.fillToothStateForm();
      // console.log('pasa this.toothStateForm.patchValue');

      this.showAddNewStateBtn=true;
      this. showLastToothStateDetailNav=false;

      // console.log('sasle de  a if(!this.showAddNewStateBtn && this. showLastToothStateDetailNav) ')
      // console.log('this.showAddNewStateBtn es:', this.showAddNewStateBtn);
      // console.log('this. showLastToothStateDetailNav es:', this. showLastToothStateDetailNav);

    }
    else{
      this.positionCurrentToothStateDetail=0;
      this.showAddNewStateBtn=true;
      this. showLastToothStateDetailNav=false;
      this.clearToothStateForm();
    }
  }
  else
  {
    //console.log('Entra al else final')
    this.clearToothStateForm();
  }
  }


  navFirstToothStateList():void{
    this.toothStateList=[... this.toothStateList];
  console.log("Entra a navFirstToothStateList");
  this.currentToothStateDetail=this.toothStateList[0];
  this.positionCurrentToothStateDetail=0;
  this.toothStateId=this.currentToothStateDetail.toothStateId.toString();
  let   layerId=this.positionInMouth+'-'+this.toothStateId;


  this.fillToothStateForm();
  this.hideAllPaths();
  this.hideEndPath();
  this.setCurrentLayer(layerId);
  this.showPath();
  }

  navLastToothStateList(){
  let size= this.toothStateList.length-1;
  this.currentToothStateDetail=this.toothStateList[size];
  this.positionCurrentToothStateDetail=this.toothStateList.length-1;
  this.toothStateId=this.currentToothStateDetail.toothStateId.toString();
  let layerId=this.positionInMouth+'-'+this.toothStateId;

  this.fillToothStateForm();
  this.hideAllPaths();
  this.hideEndPath();
  this.setCurrentLayer(layerId);
  this.showPath();

  }


  navLastToothStateList2(){
  let size= this.toothStateList.length-1;
  this.currentToothStateDetail=this.toothStateList[size];
  this.positionCurrentToothStateDetail=this.toothStateList.length-1;
  this.toothStateId=this.currentToothStateDetail.toothStateId.toString();
  let layerId=this.positionInMouth+'-'+this.toothStateId;
  this.showLastToothStateDetailNav=false;
  //this.currentToothStateDetail.selected=true;
  this.showAddNewStateBtn=true;

  this.fillToothStateForm();
  this.hideAllPaths();
  this.hideEndPath();
  this.setCurrentLayer(layerId);
  this.showPath();

  }



  navNextToothStateList(posMouth:string):void
  {
  // console.log('En navNextToothStateList this.positionCurrentToothStateDetail es:', this.positionCurrentToothStateDetail);
  // console.log('En navNextToothStateList this.toothStateList.length es:', this.toothStateList.length);
  // console.log('positionMouth is:', this.positionInMouth)
  // console.log('posMouth is:', posMouth)

  if(this.positionCurrentToothStateDetail >=0 && this.positionCurrentToothStateDetail<= this.toothStateList.length-2)
  {
  console.log('Entra al if de En navNextToothStateList ');
    this.currentToothStateDetail=this.toothStateList[this.positionCurrentToothStateDetail+1];
    this.positionCurrentToothStateDetail+=1;
    this.toothStateId=this.currentToothStateDetail.toothStateId.toString();

    let layerId=this.positionInMouth+'-'+ this.toothStateId;
    console.log('layerId es:', layerId);
    this.fillToothStateForm();
    this.hideAllPaths();
    this.hideEndPath();
    this.setCurrentLayer(layerId);
    this.showPath();
  }
  else{
  console.log('Entra al else de En navNextToothStateList ');
  }

  }

  navBackToothStateList():void
  {
    let layerId="";
    if(this.positionCurrentToothStateDetail > 0)
    {
      if(this.positionCurrentToothStateDetail== this.toothStateList.length)
      {
          this.positionCurrentToothStateDetail-=1;
      }

      this.positionCurrentToothStateDetail-=1;
      this.currentToothStateDetail=this.toothStateList[this.positionCurrentToothStateDetail];
      this.toothStateId=this.currentToothStateDetail.toothStateId.toString();
      layerId=this.positionInMouth+'-'+this.toothStateId;
     console.log('layerId is:', layerId);

    }
    this.fillToothStateForm();
    this.hideAllPaths();
    this.hideEndPath();
    this.setCurrentLayer(layerId);
    this.showPath();
  }


  clearToothStateForm():void{
  this.toothStateForm.patchValue({
  toothStateId:null,
  vestibular:null,
  medial:null,
  distal:null,
  palatino:null,
  center:null,
  fixed:null,
  observations:null,
  treatment:null,
  });

  }

    //#endregion  addNew and Navigation



  hideAllPaths(): void {
    this. pathsToProcessInHideAllPaths(this.positionInMouth);
  }

 pathsToProcessInHideAllPaths(item:string):void
 {
  console.log('Entra a pathsToProcessInHideAllPaths');
  this.pathElementsMd.forEach((path: ElementRef) => {
    this._renderer.setStyle(path.nativeElement, 'display', 'none');
    this._renderer.setStyle(path.nativeElement, 'fill', 'none');
    this._renderer.setStyle(path.nativeElement, 'stroke', 'black');

  });

  this.pathElementsMi.forEach((path: ElementRef) => {
    this._renderer.setStyle(path.nativeElement, 'display', 'none');
    this._renderer.setStyle(path.nativeElement, 'fill', 'none');
        this._renderer.setStyle(path.nativeElement, 'stroke', 'black');

  });

  this.pathElementsMain.forEach((path: ElementRef) => {
    this._renderer.setStyle(path.nativeElement, 'display', 'none');
    //this._renderer.setStyle(path.nativeElement, 'fill', 'none');

  });
  this._changeDetectorRef.detectChanges();
 }


   facesIn:number[]=[];
   facesTotal=[1,2,3,4,5];
  facesAll=this.toothFaceTypeList.map(item=>item.id);


 showPath():void
 {
    let currentTsd=this.toothStateList[this.positionCurrentToothStateDetail];
    let stateTarget=currentTsd.toothStateId;
    this.facesIn=[];
    if(this.toothStateList.length>0)
    {
        console.log('this.positionCurrentToothStateDetail es:',this.positionCurrentToothStateDetail);

        //let stringFaces:string[]=[];
        let stringFaces:BOToothStateDetailToothFace[]=[];
      stringFaces=currentTsd.toothFaces;

      stringFaces.forEach(x=>
      {
        //captura los faces para posterior process
        this.facesIn.push(x.toothFaceId);
        //captura el nombre de la face
        let nameOfFace=this.toothFaceTypeList.find(f=>f.id==x.toothFaceId).name;
        nameOfFace=this.positionInMouth+'-'+currentTsd.toothStateId+'-'+nameOfFace;

        console.log('nameofFace is:', nameOfFace);
        let path=    this.getPathByIdByMargen(this.positionInMouth,nameOfFace)

      //guardar el color y asignarlo en el renderer
        if (path) {
          console.log('Path encontrado:', path.nativeElement);
          this._renderer.setStyle(path.nativeElement, 'display', 'inline');
          this._renderer.setStyle(path.nativeElement, 'fill', x.color);
          this._renderer.setStyle(path.nativeElement, 'stroke', x.strokeColor)
          this._changeDetectorRef.detectChanges();

      } else {
          console.error('Path no encontrado');
      }
      })

      let mainPathId=this.positionInMouth +'-'+stateTarget.toString()+'-main-path';
      //let mainPath=this.getPathById(mainPathId);
      console.log('name of mainPathId is: ',mainPathId);
       console.log('this.positionInMouth is: ',this.positionInMouth);


      let mainPath=this.getPathByIdByMargen(this.positionInMouth, mainPathId, true)
      console.log('mainPath from getPathByIdByMargen: ',mainPath);

      if (mainPath) {
        console.log('mainPath encontrado:', mainPath.nativeElement);
        this._renderer.setStyle(mainPath.nativeElement, 'display', 'inline');
        this._changeDetectorRef.detectChanges();

      } else {
          console.error('mainPath no encontrado');
      }
    }
    console.log('Al salir de showPath  this.positionCurrentToothStateDetail es:',  this.positionCurrentToothStateDetail);
    console.log('Al salir de showPath  this.facesIn es:',  this.facesIn);


    if(this.facesIn.length>0)
    {
      const facesOut=this.facesTotal.filter(face=>!this.facesIn.includes(face));
      console.log('facesOut es:', facesOut);

      facesOut.forEach(face=>{
        let nameOfFace=this.toothFaceTypeList.find(f=>f.id==face).name;
        nameOfFace=this.positionInMouth+'-'+currentTsd.toothStateId+'-'+nameOfFace;

        console.log('nameofFace is:', nameOfFace);
        let path=    this.getPathByIdByMargen(this.positionInMouth,nameOfFace)

      //guardar el color y asignarlo en el renderer
        if (path)
        {
          console.log('Path encontrado:', path.nativeElement);
          this._renderer.setStyle(path.nativeElement, 'display', 'inline');
          this._renderer.setStyle(path.nativeElement, 'fill', 'none');
          this._changeDetectorRef.detectChanges();
        }


      });

//

//
    }
    else
    {

            this.facesTotal.forEach(face=>{
        let nameOfFace=this.toothFaceTypeList.find(f=>f.id==face).name;
        nameOfFace=this.positionInMouth+'-'+currentTsd.toothStateId+'-'+nameOfFace;

        console.log('nameofFace is:', nameOfFace);
        let path=    this.getPathByIdByMargen(this.positionInMouth,nameOfFace)

      //guardar el color y asignarlo en el renderer
        if (path)
        {
          console.log('Path encontrado:', path.nativeElement);
          this._renderer.setStyle(path.nativeElement, 'display', 'inline');
          this._renderer.setStyle(path.nativeElement, 'fill', 'none');
          this._changeDetectorRef.detectChanges();
        }


      });


    }
//
       let mainPathId=this.positionInMouth +'-'+stateTarget.toString()+'-main-path';
      //let mainPath=this.getPathById(mainPathId);
      console.log('name of mainPathId is: ',mainPathId);
       console.log('this.positionInMouth is: ',this.positionInMouth);


      let mainPath=this.getPathByIdByMargen(this.positionInMouth, mainPathId, true)
      console.log('mainPath from getPathByIdByMargen: ',mainPath);

      if (mainPath) {
        console.log('mainPath encontrado:', mainPath.nativeElement);
        this._renderer.setStyle(mainPath.nativeElement, 'display', 'inline');
        this._changeDetectorRef.detectChanges();

      } else {
          console.error('mainPath no encontrado');
      }

//

}

//TODO

  onToothStateChange(event:MatSelectChange)
  {
    this.hideAllPaths();
    this.hideEndPath();
      this.checkboxes.forEach(checkbox => {
        this.toothStateForm.get(checkbox.controlName)?.setValue(false);
      });

      const selectedValue= event.value;
    // Encuentra el svg
      let layerId=this.positionInMouth+'-'+event.value;
      console.log('layerId es:', this.positionInMouth+'-'+event.value);

      if(this.lastSelectedPath?.nativeElement)
      {
                  this.lastSelectedPath.nativeElement.style.display='none';
      }
      this.setCurrentLayer(layerId);


      let stateId=selectedValue.toString() +'-main-path';
      let pathId=this.positionInMouth+'-'+stateId;
      console.log('En onToothStateChange pathId es:', pathId);

      let path=this.getPathByIdByMargen(this.positionInMouth,pathId);

      let detailTemp= this.toothStateForm.get('toothStateId').value;
      let detailContent=this.toothStateTypeList.find(x=>x.id==detailTemp).name;

      this.toothStateForm.patchValue({
          observations:detailContent
       })


      if (path)
      {
        console.log('Elemento encontrado:', path.nativeElement);
        this._renderer.setStyle(path.nativeElement, 'display', 'inline');

    this.currentToothStateDetail=this.toothStateList[this.positionCurrentToothStateDetail];
    console.log('sale de onToothStateChange');
    console.log('En onToothStateChange this.positionCurrentToothStateDetail es: ',this.positionCurrentToothStateDetail);
    console.log('En onToothStateChange this.currentToothStateDetail es: ',this.currentToothStateDetail);

      } else {
          console.error('Elemento no encontrado');
      }

  }

  onToothStateChangeFromIcon(target:number, stateSelected?:string)
  {
    console.log('Entra a onToothStateChangeFromIcon');
    //let detailTemp= this.toothStateForm.get('observations').value;
    this.toothStateForm.patchValue({
      observations:stateSelected
    })
    this.hideAllPaths();
    this.hideEndPath();

      this.checkboxes.forEach(checkbox => {
        this.toothStateForm.get(checkbox.controlName)?.setValue(false);
      });

      const selectedValue= target;
      let targetString=target.toString();

    // Encuentra el svg
      let layerId=this.positionInMouth+'-'+targetString;
      console.log('layerId es:', this.positionInMouth+'-'+targetString);
      this.setCurrentLayer(layerId);


      let stateId=selectedValue.toString() +'-main-path';
      console.log("En onToothStateChange this.toothStateId es:",this.toothStateId,  " y stateId es:", stateId);
      console.log("En onToothStateChange selectedValue es:", selectedValue);
      this.toothStateId=selectedValue.toString();
      let pathId=this.positionInMouth+'-'+stateId;
      console.log('En onToothStateChange pathId es:', pathId);
      let path=this.getPathByIdByMargen(this.positionInMouth,pathId, true);


      if (path)
      {
            console.log('Elemento encontrado:', path.nativeElement);
            this._renderer.setStyle(path.nativeElement, 'display', 'inline');

          //  let posState=this.getElementPosition(path);

          this.toothStateForm.patchValue({
                toothStateId:target,
          });
  console.log('Pasa  this.toothStateForm.patchValue');

              console.log('this.toothStateList es:', this.toothStateList);
              console.log('this.currentToothStateDetail es:', this.currentToothStateDetail);
              console.log('this.positionCurrentToothStateDetail es:',this.positionCurrentToothStateDetail)


      } else {
          console.error('Elemento no encontrado');
      }

  }

// En tu componente (.ts)
  getElementPosition(element: BOToothStateDetail): number {
    const index = this.toothStateList.findIndex(item =>
      item.id === element.id // Asumiendo que 'id' es único
    );

  // console.log('Posición del elemento:', index, 'type is:', typeof index);
    return index;
    // Aquí puedes usar el índice como necesites
  }


  onClickFromShortListToAreaTooth(element: BOToothStateDetail):void
  {
     console.log('Entra a onClickFromShortListAreaTooth- click de ResumeTable')
     console.log('En onClick..this.toothStateList  es:', this.toothStateList);
     console.log('Al Entrar onClick..this.positionCurrentToothStateDetail  es:', this.positionCurrentToothStateDetail);
    //this.positionCurrentToothStateDetail=-5;
    // console.log('En onClick..this.positionInMouth is:', this.positionInMouth);
  this.toothStateList = this.toothStateList
  .map(item => ({ ...item, selected: false }));


    this.toothStateList=[... this.toothStateList];
    let posState=this.getElementPosition(element);

    this.toothStateList[posState].selected=true;
    let stateId=element.toothStateId;
    let layerId= this.positionInMouth+'-'+stateId;
   // console.log('Layer target is:', layerId);
   this.selectToothStateDetail(element); // ← reemplaza la lógica de resaltado
      this.setCurrentLayer(layerId);
   // this.getCheckboxValues(stateId);
  this.currentToothStateDetail=this.toothStateList[posState];

  this.currentToothStateDetail.selected=true;


  this.positionCurrentToothStateDetail=posState;
  this._changeDetectorRef.detectChanges();
  // console.log('En ResumeTable posState posicion del state es: ',posState);
   console.log('Al salir de ONCLICK... this.positionCurrentToothStateDetail es: ',this.positionCurrentToothStateDetail);
  // console.log('En ResumeTable this.currentToothStateDetail es: ',this.currentToothStateDetail);
      this.hideAllPaths();
        this.hideEndPath();
      this.showPath();
      this.fillToothStateForm();

  }

  getPathById(id: string, positionMargin:string): ElementRef | undefined
  {

  if(positionMargin=='md-up' || positionMargin=='md-bottom')
  {
    return this.pathElementsMd.find(
      (path: ElementRef) => path.nativeElement.id === id
    );

  }
  else{
    return this.pathElementsMi.find(
      (path: ElementRef) => path.nativeElement.id === id
    );
  }


  }

  getPathByIdByMargen(item:string,id:string,isMain?:boolean):ElementRef{

    let result: ElementRef;
    let comodin:ElementRef=null;

    if(isMain)
    {
      item='main';
    }

    switch (item) {
      case 'md-up':
        result= this.pathElementsMd.find(
          (path: ElementRef) => path.nativeElement.id === id
      );
        break;

      case 'mi-up':
        result= this.pathElementsMi.find(
          (path: ElementRef) => path.nativeElement.id === id
      );
        break;

      case 'md-bottom':
        result= this.pathElementsMd.find(
          (path: ElementRef) => path.nativeElement.id === id
        );
        break;

      case 'mi-bottom':
        result= this.pathElementsMi.find(
          (path: ElementRef) => path.nativeElement.id === id
        );
        break;

      case 'main':
        result= this.pathElementsMain.find(
          (path: ElementRef) => path.nativeElement.id === id
      );
        break;

      default:
        result = comodin;
    }
    //console.log('sale de getPathByIdMargen');
    return result;


  }

  onToothChange(event:MatSelectChange):void
  {
    console.log('Entra a onToothChange');
    this.hideAllPaths();

    const selectedValue= event.value;
    let odontogramId=this.odontogramaId;

    this.toothId=selectedValue.toString();
    let toothIdInt=parseInt(this.toothId);

    this.showIncisal=false;
    if(this.teethWithIncisal.includes(toothIdInt)) this.showIncisal=true;


    this.selectedToothTypeId==selectedValue;

    //TODO debe encontrar positionInMouth
   this.positionInMouth= this.toothTypeList.find(x=> x.id==selectedValue).positionInMouth;
      console.log('this.positionInMouth is:',  this.positionInMouth);

    this._toothStateDetail.getToothStateDetailsByToothIdPersonIdOdontogramaId(selectedValue,this.personId,odontogramId)
              .subscribe({
                next: data=> {
                  this.toothStateList=data;

                  if(this.toothStateList.length>0)
                    {
                      if(this.lastSelectedPath?.nativeElement)
                      {
                                  this.lastSelectedPath.nativeElement.style.display='none';
                      }

                      // this.positionInMouth= this.toothTypeList.find(x=> x.id==selectedValue).positionInMouth;
                      // console.log('In subscribe  this.positionInMouth is:',  this.positionInMouth);

                      this.showAddNewStateBtn=true;
                      this.showLastToothStateDetailNav=false;
                      this.currentToothStateDetail=this.toothStateList[0];
                      this.toothStateId=this.currentToothStateDetail.toothStateId.toString();
                      this.positionCurrentToothStateDetail=0;
                      let layerId=this.positionInMouth+'-'+this.toothStateId;
                        this.hideAllPaths();
                        this.hideEndPath();
                        this.setCurrentLayer(layerId);

                      this.showPath();
                      this.fillToothStateForm();


                  }
                  else
                  {
                      this.currentToothStateDetail=null;
                      this.positionInMouth=this.positionInMouth;
                      this.hideAllPaths();

                      if(this.lastSelectedPath?.nativeElement)
                      {
                                  this.lastSelectedPath.nativeElement.style.display='none';

                      }
                      this.fillToothStateForm();

                    }

                },
              error:(err)=>{
                error: (error) => console.error('Error cargando datos de diente:', error)

              },
              complete:()=>{
                console.log('Se cargaron los datos a this.tootStateList:', this.toothStateList);
              }
            });
  }

  setCurrentLayer(layerTarget:string):void
  {
      this.svgLayers.forEach(sv =>
      {
        const el = sv.nativeElement as SVGElement;

        if (el.id === 'base' || el.id === layerTarget)
        {
          el.setAttribute('style', 'display: inline; position: absolute; top: 0; left: 0; width: 100%; height: 100%;');
            if (el.id === layerTarget)
            {

              this.getSvgByIdAsElementRef(el.id);
              const pathsOfChoose = el.querySelectorAll('path, circle');
              pathsOfChoose.forEach((p: SVGElement) => {
                p.style.display='inline';
              // p.style.fill = 'none';
              });
            }

        }
        else
        {
          el.setAttribute('style', 'display: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%;');
        }
        });


  }

 extractNumber(pathId: string): number | null
 {
  const regex = /-(?:up|bottom)-(\d+)-/;
  const match = pathId.match(regex);
  return match ? parseInt(match[1], 10) : null;
 }

  extractNumberAndZone(input: string): ExtractedInfo
  {
    const regex = /-(?:up|bottom)-(\d+)-(\w+)$/;
    const match = input.match(regex);
    if (match) {
      const number = parseInt(match[1], 10);
      const zone = match[2];
      return { number, zone };
    }
    return null;
  }

  zoneToNumber(zone: string): string {
  switch (zone.toLowerCase()) {
    case 'vestibular':
      return 'V';
    case 'medial':
      return 'M';
    case 'distal':
      return 'D';
    case 'palatino':
      return 'p';
    default:
      return 'O'; // cualquier otra zona entra aquí
  }
}


zoneToForm(zone: string):void{
  switch (zone.toLowerCase()) {
    case 'vestibular':
      if(this.toothStateForm.get('vestibular').value==false)
      this.toothStateForm.get('vestibular').setValue(true);

      break;
    case 'medial':
      if(this.toothStateForm.get('medial').value==false)
      this.toothStateForm.get('medial').setValue(true);
          break;

    case 'distal':
      if(this.toothStateForm.get('distal').value==false)
      this.toothStateForm.get('distal').setValue(true);
          break;

    case 'palatino':
      if(this.toothStateForm.get('palatino').value==false)
      this.toothStateForm.get('palatino').setValue(true);
          break;

    default:
      if(this.toothStateForm.get('center').value==false)
      this.toothStateForm.get('center').setValue(true);
          break;

  }
}

getColorFromFaces(paths:NodeListOf<SVGElement>, layerId:string):string
{
  console.log('Entra a getColorFromFaces, layerIde is:', layerId);
 const targetPath = Array.from(paths).find(el => el.id === layerId);
            const styleAttr = targetPath.getAttribute('style');
            const fillMatch = styleAttr?.match(/fill:([^;]+)/);
            const fillColor = fillMatch ? fillMatch[1].trim() : null;
            return fillColor;
}

getStrokeFromFaces(paths: NodeListOf<SVGElement>, layerId: string): string {
  //console.log('Entra a getStrokeFromFaces, layerId is:', layerId);
  const targetPath = Array.from(paths).find(el => el.id === layerId);
  const styleAttr = targetPath?.getAttribute('style');
  const strokeMatch = styleAttr?.match(/stroke:([^;]+)/);
  const strokeColor = strokeMatch ? strokeMatch[1].trim() : null;
  return strokeColor;
}

onClickOnBaseLayer():void{
  this._toastr.error('Requiere Selección','Seleccione una capa');
}

  getSvgByIdAsElementRef(svgId: string): ElementRef<SVGSVGElement> | null {
        console.log('Entra a getSvgByIdAsElement. svgId es:', svgId);

    if (!this.svgLayers) {
      //console.warn('ViewChildren no está inicializado aún');
      return null;
    }

    //console.log('this.svgLayers is:', this.svgLayers);
    const svgFound = this.svgLayers.find(svg => {
      const element = svg.nativeElement;
      return element.id === svgId;
    });
    this.lastSelectedPath=svgFound;
   // console.log('lastSelectedPath set in getSvgByIdAsElement is:', this.lastSelectedPath);
    return svgFound || null;
  }

  setBaseCurrentLayer(layerTarget:string):void
  {
      this.svgLayers.forEach(sv =>
      {
        const el = sv.nativeElement as SVGElement;
       console.log('Enta a setBaseCurrentLayer');
       console.log('En setBaseCurrentLayer el data-svg-id is:', el.getAttribute('data-svg-id'));        if (el['data-svg-id']=='base-md-up')
        {

            if (el.getAttribute('data-svg-id') == 'base-md-up')
            {

              el.setAttribute('style', 'display: inline; position: absolute; top: 0; left: 0; width: 100%; height: 100%;');

              const pathsOfChoose = el.querySelectorAll('path, circle');
              pathsOfChoose.forEach((p: SVGElement) => {
                p.style.display='inline';
              // p.style.fill = 'none';
              });
              console.log('En setCurrentLayer layerTarget is:', el);
            }

        }
        else
        {
          el.setAttribute('style', 'display: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%;');
        }
        });
  }

  hideEndPath():void{
    this._renderer.setStyle(this.endPath.nativeElement,'display', 'none');
  }


  //voice Recorder
   private clearForm(): void {
    this.toothStateForm.reset();
    this.toothStateForm.patchValue({
      vestibular: false,
      medial: false,
      distal: false,
      palatino: false,
      center: false,
      fixed: false
    });
  }


  public onVoiceCommandReceived(command: string): void {
    switch (command.toLowerCase()) {
      case 'guardar':
        this.saveToothStateDetail2();
        break;
      case 'limpiar formulario':
        this.clearForm();
        break;
      case 'marcar terminado':
        this.toothStateForm.patchValue({ fixed: true });
        break;
      // Agregar más comandos según sea necesario
    }
  }

  //NUEVP
  public  selectToothById(id: number)
  {
    const exists = this.toothTypeList.find(t => t.id === id);
    if (exists) {
      this.selectedToothTypeId = id;
      this.toothSelect.close();
    } else {
      console.warn(`Diente ${id} no encontrado`);
    }
  }

startVoiceWriting():void{
  this._voiceService.startVoiceWriting();
}

stopVoiceWriting(){
  this._voiceService.stopVoiceWriting();
  this.stopSignal = !this.stopSignal;
}

getCheckbox(lastLetter: string): MatCheckbox
{
  switch (lastLetter) {
    case 'v':
      return this.vestibularCheckbox;
    case 'd':
      return this.distalCheckbox;
    case 'm':
      return this.medialCheckbox;
    case 'p':
      return this.palatinoCheckbox;
    case 'c':
      return this.centerCheckbox;
  }
}

getPathNameFromCheckbox(idSended: string): string {
  const lastLetter = idSended.trim();
  switch (lastLetter) {
    case 'v':
      return 'vestibular';
    case 'd':
      return 'distal';
    case 'm':
      return 'medial';
    case 'p':
      return 'palatino';
    case 'c':
      return 'center';
    default:
      return '';
  }
}

processSelectCheck(letter:string)
{
 console.log('Entra a select-check' +letter);
 let cb:MatCheckbox;
// cb=this.vestibularCheckbox;
 cb=this.getCheckbox(letter);
 console.log('ProcessSelectCheck cb asignado xon getCheckbox es:', cb);
console.log('ProcessSelectCheck antes de cb.toggle(), this.vestibularCheckbox es:', cb.checked);
 cb.toggle();
 console.log('ProcessSelectCheck después de cb.toggle(), this.vestibularCheckbox es:', cb.checked);

// Crear un evento MatCheckboxChange manual
  const checkboxChangeEvent: MatCheckboxChange = {
    source: cb,
    checked:cb.checked
  };


  let zone= this.getPathNameFromCheckbox(letter);
  console.log("En psc zone es:", zone);
  const cbId=cb.id;
    console.log("En psc cbId es:", cbId);
  let stateNumberString= this.toothStateForm.get('toothStateId').value;
    console.log("En psc this.toothStateId es:", this.toothStateId);
  const pathId=this.positionInMouth+'-'+this.toothStateId+"-"+cbId;
  console.log("En psc pathId es:", pathId);

    let stateNumber= parseInt(stateNumberString)
    this.currentColor.stateId=stateNumber;
    this.currentColor.zone=zone;

  const pathChoosed= document.getElementById(pathId);
  console.log("En ngOnInit patChoosed es:", pathChoosed);

   // let stateNumber=parseInt(this.toothStateId)
    this.getCheckboxValues(stateNumber);

  if (pathChoosed)
  {
    const color = pathChoosed.style.fill;
    if(cb.checked==false)
    {
      pathChoosed.style.fill='none';
    }
    else{
    let choosedColor= this.stateVerify(color, pathChoosed, zone);

    }

    //const stroke= target2.style.stroke;

  }


//  this._toastr.success("Checkbox", "captura Checkbox "+ zone);


}
deleteItem(itemx: number,element:BOToothStateDetail)
{
  this.confirmDeleteItem(itemx, element);

}

goToFirstState(element: BOToothStateDetail):void
{
  let posState=0;
  let stateId=this.toothStateList[0].toothStateId;
  let layerId= this.positionInMouth+'-'+stateId;
  // console.log('Layer target is:', layerId);
    this.setCurrentLayer(layerId);
  // this.getCheckboxValues(stateId);
  this.currentToothStateDetail=this.toothStateList[posState];
  this.positionCurrentToothStateDetail=posState;
  this.hideAllPaths();
  this.hideEndPath();
  this.showPath();
  this.fillToothStateForm();
  this._toastr.success("Éxito", "Se borró el diagnóstico");
  this._changeDetectorRef.detectChanges();
}

cleanState()
{
  this.hideAllPaths();
  this.hideEndPath();
  //this.dataUpdated.emit();

}


confirmDeleteItem(itemx:number, element:BOToothStateDetail):void
{
  let confirm:boolean=false;

  this._dialogConfirm.openConfirmDialog('¿Está seguro de que desea borrar este diagnóstico? ')
  .afterClosed().subscribe({
    next:(res)=>
    {
      confirm=res;
      if(confirm)
      {
        this._toothStateDetail.deleteStateDetail(element.id).subscribe(x=>{

          if(x==0) console.log("No se borró el diagnóstico");
          else console.log("ÉXITO, se borró el diagnóstico");

          console.log("Entra a deleteItem, this.toothStateList es:", this.toothStateList, " itemx es:", itemx);

          //para reset
          // let svgStateErased=this.positionInMouth +'-'+element.toothStateId.toString().trim();
          // this.resetSvgStyles(svgStateErased);

          this.toothStateList=this.toothStateList.filter((_, index) => index !== itemx);
          if(this.toothStateList.length>0)
          {
            console.log("TSComponent, entra a this.toothStateList.length>0");
            //this.dataUpdated.emit({toothId:element.toothTypeId, stateId:element.toothStateId});
           // this.dataUpdated.emit();
            this.toothStateList=[... this.toothStateList];


            this.currentToothStateDetail=this.toothStateList[0];
            this.positionCurrentToothStateDetail=0;
            this.toothStateId=this.currentToothStateDetail.toothStateId.toString();
            let   layerId=this.positionInMouth+'-'+this.toothStateId;
            this.selectToothStateDetail(this.toothStateList[0]); // ← reemplaza la lógica de resaltado

            this.fillToothStateForm();
            this.hideAllPaths();
            this.hideEndPath();
            this.setCurrentLayer(layerId);
            this.showPath();
           /////////
           this.stateErased.emit({toothId:element.toothTypeId, stateId:element.toothStateId});

          }
          else
          {
            console.log("TSComponent, entra a this.toothStateList.length<=0");

            this.cleanState();

            //this.showPath();
            this.stateErased.emit({toothId:element.toothTypeId, stateId:element.toothStateId});
          }

         // this.dataUpdated.emit();
          if(this.toothStateList.length==0)return;
          if (!this.toothStateList[itemx]) return;

        });

        this._changeDetectorRef.detectChanges();
        //console.log("sale de  deleteItem, this.toothStateList es:",this.toothStateList);
      }
      else
      {
        this._toastr.error("Fracaso", "No se borró el diagnóstico");
        this.close();
      }
    },
    error:(err)=>{

    }


});

}

resetSvgStyles(svgId: string): void
{
  console.log("Entra a resetSvgStyles");
    const svgElement = document.getElementById(svgId) as unknown as SVGSVGElement;

    if (!svgElement) {
      console.warn(`SVG con id "${svgId}" no encontrado`);
      return;
    }

    // Obtener todos los paths dentro del SVG
    const paths = svgElement.querySelectorAll('path');
    const circle=svgElement.querySelector('circle');

    paths.forEach((path: SVGPathElement) => {
      path.style.fill = 'none';
      path.style.stroke = '#010200';

      // Opcional: también puedes modificar los atributos inline si es necesario
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', '#010200');
    });
//circle
    circle.style.fill='none';
    circle.style.stroke='#010200';
    circle.setAttribute('fill', 'none');
    circle.setAttribute('stroke', '#010200');

    console.log(`Se procesaron ${paths.length} paths del SVG #${svgId}`);
 }
private selectToothStateDetail(element: BOToothStateDetail): void {
  // Limpia el selected de todos los elementos
  this.toothStateList.forEach(item => item.selected = false);
  // Marca solo el elemento clickeado
  element.selected = true;
  this.toothStateList = [...this.toothStateList]; // fuerza detección de cambios
}

ngOnDestroy(): void
{
this.busyData$?.unsubscribe();
this.voiceSub.unsubscribe();
}

}


